<template>
    <div class="orchester-page">
        <!-- ① TICKER TOP -->
        <div class="ticker-bar">
            <p v-for="(item, index) in 25" :key="index" class="ticker-text">
                +++ Exklusives Event <span style="font-weight: 600">für ausgewählte Gäste</span> +++ Ein Abend, der <span style="font-weight: 600">Musik und Märkte</span> neu
                verbindet +++ Dialog, Vielfalt und <strong>neue Denkansätze</strong> +++
            </p>
        </div>

        <!-- ② HERO SECTION -->
        <section class="hero-section">
            <!-- Background layers -->
            <div class="hero-bg"></div>
            <div class="hero-gradient"></div>

            <img :src="$asset('/hkcm/images/orchester/hero_concert.png', 'public')" class="hero-concert-img" alt="" aria-hidden="true" />
            <div class="hero-gradient-overlay"></div>

            <!-- NAV -->
            <div class="hero-nav-wrap">
                <nav class="hero-nav">
                    <router-link to="/">
                        <img :src="$asset('/hkcm/images/logo-on-dark-background.svg', 'public')" class="hero-logo" alt="HKCM" />
                    </router-link>
                    <div class="hero-nav-links">
                        <a href="/impressum" class="hero-nav-link">Impressum</a>
                        <a href="/agb" class="hero-nav-link">AGB</a>
                        <a href="/datenschutz" class="hero-nav-link">Datenschutz</a>
                    </div>
                    <a href="https://partnershop.easyticket.de/1eb7fd2b345e9e5b144581cb5cb5f927/event/105586/" class="hero-nav-cta">Jetzt Tickets buchen.</a>
                </nav>
            </div>

            <!-- HERO CONTENT -->
            <div class="hero-content-wrap">
                <div class="hero-content">
                    <!-- Title + subtitle -->
                    <div class="hero-title-area">
                        <h1 class="hero-title">Wenn <span style="color: #006cff">Kulturen</span> gemeinsam klingen,<br />entsteht etwas Größeres.</h1>
                        <p class="hero-subtitle">
                            Exklusives Konzert des Orchesters der Kulturen<br />
                            13. Juni 2026 &nbsp;|&nbsp; Liederhalle Stuttgart<br />
                            Für ausgewählte HKCM Kunden
                        </p>
                    </div>
                    <!-- CTA Button -->
                    <a href="https://partnershop.easyticket.de/1eb7fd2b345e9e5b144581cb5cb5f927/event/105586/" class="hero-cta-btn">
                        Jetzt Tickets buchen
                        <img :src="$asset('/hkcm/images/orchester/arrow_right_icon.svg', 'public')" style="width: 24px; height: 24px; filter: brightness(0) invert(1)" alt="" />
                    </a>
                    <!-- Badges row -->
                    <div class="hero-badges-row">
                        <div class="hero-store-badges">
                            <!--                            <div class="store-badge-item">-->
                            <!--                                <img :src="$asset('/hkcm/images/apple-store-badge.png', 'public')" class="store-badge-img" alt="App Store" />-->
                            <!--                                <div class="store-rating">-->
                            <!--                                    <span class="store-rating-num">4.4</span>-->
                            <!--                                    <img :src="$asset('/hkcm/images/stars4_5_yellow.png', 'public')" style="height: 14px" alt="4.4 Sterne" />-->
                            <!--                                    <span class="store-rating-num">1.8k</span>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                            <!--                            <div class="store-badge-item">-->
                            <!--                                <img :src="$asset('/hkcm/images/google-play-badge.png', 'public')" class="store-badge-img" alt="Google Play" />-->
                            <!--                                <div class="store-rating">-->
                            <!--                                    <span class="store-rating-num">4.5</span>-->
                            <!--                                    <img :src="$asset('/hkcm/images/stars4_5_green.png', 'public')" style="height: 14px" alt="4.5 Sterne" />-->
                            <!--                                    <span class="store-rating-num">7.3k</span>-->
                            <!--                                </div>-->
                            <!--                            </div>-->
                        </div>
                        <div class="hero-award-badges">
                            <div class="award-badge-circle">
                                <img :src="$asset('/hkcm/images/orchester/badge_blackbull.jpg', 'public')" alt="Black Bull Award" />
                            </div>
                            <div class="award-badge-circle">
                                <img :src="$asset('/hkcm/images/orchester/badge_investment1.jpg', 'public')" alt="Investment Award" />
                            </div>
                            <div class="award-badge-circle">
                                <img :src="$asset('/hkcm/images/orchester/badge_investment2.png', 'public')" alt="Award" />
                            </div>
                        </div>
                        <!--Shadow-->
                    </div>
                </div>
            </div>
        </section>

        <!-- ③ VIDEO + ÜBERZEUGUNG SECTION -->
        <section class="ueberzeugung-section">
            <!-- Video Player -->
            <div class="video-outer">
                <div class="video-inner">
                    <div style="position: relative; padding-top: 56.25%">
                        <iframe
                            src="https://iframe.mediadelivery.net/embed/369702/654292fe-15a3-4d41-a6ca-ff5dc9e39340?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                            loading="lazy"
                            style="border: 0; position: absolute; top: 0; height: 100%; width: 100%"
                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                            allowfullscreen="true"
                        ></iframe>
                    </div>
                </div>
                <div></div>
            </div>

            <!-- Content -->
            <div class="ueberzeugung-content">
                <div class="section-badge">Unsere Überzeugung</div>
                <h2 class="ueberzeugung-title"><span style="color: #006cff">Vielfalt</span> ist mehr als ein Schlagwort.</h2>
                <div class="ueberzeugung-texts">
                    <p class="body-text-dark">
                        Märkte sind global.<br />
                        Kapital bewegt sich über Grenzen.<br />
                        Entscheidungen entstehen im Zusammenspiel unterschiedlicher Perspektiven.
                    </p>
                    <p class="body-text-dark">
                        Das Orchester der Kulturen steht für genau dieses Prinzip: Menschen mit verschiedenen kulturellen Hintergründen schaffen gemeinsam Harmonie.
                    </p>
                    <p class="body-text-dark">Dieser Gedanke verbindet sich mit unserem Anspruch bei HKCM:<br />Struktur schaffen - ohne Vielfalt zu verlieren.</p>
                    <p class="body-text-dark">Mit diesem Abend möchten wir ein Zeichen setzen: für Offenheit, kulturellen Dialog und gegenseitigen Respekt.</p>
                </div>
            </div>
        </section>

        <!-- ④ VERBINDUNG SECTION (dark blue, horizontal layout) -->
        <section class="verbindung-section">
            <div class="verbindung-bg"></div>
            <div class="verbindung-gradient"></div>
            <div class="verbindung-content-wrap">
                <div class="verbindung-media">
                    <!-- Video -->
                    <div class="verbindung-video-outer">
                        <div class="verbindung-video-inner" style="padding-top: 56.3%">
                            <iframe
                                src="https://iframe.mediadelivery.net/embed/369702/0d4b6e7c-e85e-4c69-9716-729cd6a8bd13?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                loading="lazy"
                                style="border: 0; position: absolute; top: 0; height: 100%; width: 100%"
                                allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                allowfullscreen="true"
                            ></iframe>
                        </div>
                    </div>
                    <!--Instagram-->
                    <a href="https://www.instagram.com/orchesterderkulturen/" target="_blank" class="verbindung-instagram-link">
                        <div
                            style="
                                border-radius: 50px;
                                margin-top: 12px;
                                display: flex;
                                align-items: center;
                                gap: 8px;
                                background: #006cff;
                                padding: 20px;
                                width: fit-content;
                                justify-self: center;
                            "
                        >
                            <i class="fi fi-brands-instagram" style="color: white; display: flex" />
                            <p style="color: white; font-size: 20px">Instagram</p>
                        </div>
                    </a>
                </div>
                <!-- Text -->
                <div class="verbindung-text">
                    <div>
                        <div class="section-badge">Verbindung</div>
                        <h2 class="verbindung-title"><span style="color: #006cff">Musik</span> als Brücke zwischen Welten.</h2>
                    </div>
                    <div>
                        <p class="body-text-white" style="margin-bottom: 20px">
                            Das Orchester der Kulturen vereint Musikerinnen und Musiker mit unterschiedlichsten kulturellen Traditionen.
                        </p>
                        <div class="verbindung-features">
                            <div class="feature-row">
                                <img :src="$asset('/hkcm/images/orchester/music_icon.svg', 'public')" style="width: 24px; height: 24px; flex-shrink: 0" alt="" />
                                <span class="body-text-white" style="">Unterschiedliche Klangfarben.</span>
                            </div>
                            <div class="feature-row">
                                <img :src="$asset('/hkcm/images/orchester/music_icon.svg', 'public')" style="width: 24px; height: 24px; flex-shrink: 0" alt="" />
                                <span class="body-text-white">Unterschiedliche musikalische Prägungen.</span>
                            </div>
                            <div class="feature-row">
                                <img :src="$asset('/hkcm/images/orchester/music_icon.svg', 'public')" style="width: 24px; height: 24px; flex-shrink: 0" alt="" />
                                <span class="body-text-white">Ein gemeinsames Werk.</span>
                            </div>
                        </div>
                    </div>
                    <p class="verbindung-quote">
                        <span style="color: #006cff; font-weight: 600">Am 13. Juni 2026</span> erleben Sie dieses Zusammenspiel live in der Liederhalle Stuttgart, einem der
                        bedeutendsten Konzerthäuser Deutschlands. Ein Abend, der kulturelle Vielfalt hörbar macht.
                    </p>
                </div>
            </div>
        </section>

        <!-- ⑤ SYNERGIE SECTION (white, horizontal layout) -->
        <section class="synergie-section">
            <div class="synergie-content-wrap">
                <!-- Text left -->
                <div class="synergie-text">
                    <div>
                        <div class="section-badge">Synergie</div>
                        <h2 class="synergie-title">Was <span style="color: #006cff">Märkte und Musik</span> verbindet.</h2>
                    </div>
                    <div class="synergie-list-area">
                        <p class="body-text-dark">Auch Märkte sind ein Zusammenspiel aus:</p>
                        <div class="synergie-features">
                            <div class="feature-row">
                                <img :src="$asset('/hkcm/images/orchester/music_icon_blue.svg', 'public')" style="width: 24px; height: 24px; flex-shrink: 0" alt="" />
                                <span class="body-text-dark">Unterschiedlichen Interessen</span>
                            </div>
                            <div class="feature-row">
                                <img :src="$asset('/hkcm/images/orchester/music_icon_blue.svg', 'public')" style="width: 24px; height: 24px; flex-shrink: 0" alt="" />
                                <span class="body-text-dark">Verschiedenen Perspektiven</span>
                            </div>
                            <div class="feature-row">
                                <img :src="$asset('/hkcm/images/orchester/music_icon_blue.svg', 'public')" style="width: 24px; height: 24px; flex-shrink: 0" alt="" />
                                <span class="body-text-dark">Globalen Einflüssen</span>
                            </div>
                        </div>
                    </div>
                    <p class="body-text-dark">
                        Wer nur eine Stimme hört, versteht das Ganze nicht. Unser Anspruch bei HKCM ist es, diese unterschiedlichen Kräfte analytisch einzuordnen, ohne ihre
                        Vielfalt zu ignorieren.<br/>Deshalb bringt das HKCM Phantom seine Passion nicht nur in die Analysen ein, sondern auch gesanglich bei diesem besonderen Event.
                        Dieser Konzertabend ist Ausdruck dieses Selbstverständnisses.
                    </p>
                </div>

                <!-- Video Player -->
                <div class="video-outer synergie-video-outer">
                    <div class="video-inner synergie-video-inner">
                        <div style="position: relative; padding-top: 56.25%">
                            <iframe
                                src="https://iframe.mediadelivery.net/embed/369702/4a48ae79-d45b-42f1-8fa5-50c4e0d9a591?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                loading="lazy"
                                style="border: 0; position: absolute; top: 0; height: 100%; width: 100%"
                                allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                allowfullscreen="true"
                            ></iframe>
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </section>

        <!-- ⑥ DIALOG/BEGEGNUNG SECTION (dark, centered) -->
        <section class="dialog-section">
            <div class="dialog-bg"></div>
            <div class="dialog-gradient"></div>
            <div class="dialog-content-wrap">
                <div class="dialog-header">
                    <div class="section-badge">Begegnung</div>
                    <h2 class="dialog-title"><span style="color: #006cff">Dialog</span> statt Distanz</h2>
                </div>
                <p class="body-text-white" style="text-align: center">Im Anschluss an das Konzert laden wir Sie Herzlich zu einem exklusiven Austausch ein:</p>
                <div class="dialog-cards">
                    <div class="dialog-card">
                        <img :src="$asset('/hkcm/images/orchester/icon_youtube_creators.svg', 'public')" class="dialog-card-icon" alt="" />
                        <div class="dialog-card-divider"></div>
                        <p class="dialog-card-text">Mit unseren YouTube-Creatoren</p>
                    </div>
                    <div class="dialog-card">
                        <img :src="$asset('/hkcm/images/orchester/icon_orchestra_director.svg', 'public')" class="dialog-card-icon" alt="" />
                        <div class="dialog-card-divider"></div>
                        <p class="dialog-card-text">Mit dem Dirigenten des Orchesters</p>
                    </div>
                    <div class="dialog-card">
                        <img :src="$asset('/hkcm/images/orchester/icon_guests.svg', 'public')" class="dialog-card-icon" alt="" />
                        <div class="dialog-card-divider"></div>
                        <p class="dialog-card-text">Mit ausgewählten Gästen aus dem HKCM-Umfeld</p>
                    </div>
                </div>
                <p class="body-text-white" style="text-align: center">
                    <strong>Keine Bühne. Kein Verkaufsrahmen.</strong><br />
                    Sondern Gespräche über Perspektiven, Märkte und kulturelle Verbindungen.
                </p>
            </div>
        </section>

        <!-- ⑦ EVENT DETAILS SECTION (cream) -->
        <section class="event-section">
            <div class="event-box-wrap">
                <div class="event-box">
                    <!-- Corner decorations -->
                    <img :src="$asset('/hkcm/images/orchester/corner_br.svg', 'public')" class="corner corner-tl" alt="" />
                    <img :src="$asset('/hkcm/images/orchester/corner_tl.svg', 'public')" class="corner corner-tr" alt="" />
                    <img :src="$asset('/hkcm/images/orchester/corner_bl.svg', 'public')" class="corner corner-bl" alt="" />
                    <img :src="$asset('/hkcm/images/orchester/corner_tr.svg', 'public')" class="corner corner-br" alt="" />

                    <div class="event-inner">
                        <div class="event-header">
                            <h2 class="event-title">
                                Ein besonderer Rahmen für<br />
                                <span style="color: #006cff">besondere Gäste</span>
                            </h2>
                            <p class="body-text-dark" style="text-align: center">
                                Dieses Event richtet sich ausschließlich an ausgewählte HKCM Top-Kunden.<br />
                                Die Teilnehmerzahl ist bewusst limitiert, um eine persönliche Atmosphäre zu gewährleisten.
                            </p>
                        </div>

                        <div class="event-meta">
                            <div class="event-meta-row">
                                <div class="event-meta-item">
                                    <div class="event-meta-icon-wrap">
                                        <img :src="$asset('/hkcm/images/orchester/pin_icon.svg', 'public')" style="width: 24px; height: 24px" alt="" />
                                    </div>
                                    <p class="event-meta-text"><strong>Ort:</strong><br />Liederhalle Stuttgart</p>
                                </div>
                                <div class="event-meta-item">
                                    <div class="event-meta-icon-wrap">
                                        <img :src="$asset('/hkcm/images/orchester/calendar_icon.svg', 'public')" style="width: 24px; height: 24px" alt="" />
                                    </div>
                                    <p class="event-meta-text"><strong>Datum:</strong><br />13. Juni 2026</p>
                                </div>
                            </div>

                            <div class="event-timeline-wrap">
                                <div class="event-timeline-bar"></div>
                                <div class="event-timeline">
                                    <div class="timeline-item">
                                        <div class="timeline-icon-wrap">
                                            <img :src="$asset('/hkcm/images/orchester/clock_icon.svg', 'public')" style="width: 30px; height: 30px" alt="" />
                                        </div>
                                        <p class="timeline-time"><strong>18:00 Uhr</strong><br />Einlass</p>
                                    </div>
                                    <div class="timeline-item">
                                        <div class="timeline-icon-wrap">
                                            <img :src="$asset('/hkcm/images/orchester/clock_icon1900.png', 'public')" style="width: 30px; height: 30px" alt="" />
                                        </div>
                                        <p class="timeline-time"><strong>19:00 Uhr</strong><br />Konzertbeginn</p>
                                    </div>
                                    <div class="timeline-item">
                                        <div class="timeline-icon-wrap">
                                            <img :src="$asset('/hkcm/images/orchester/clock_icon2100.png', 'public')" style="width: 30px; height: 30px" alt="" />
                                        </div>
                                        <p class="timeline-time"><strong>ca. 21:00 Uhr</strong><br />Meet &amp; Greet</p>
                                    </div>
                                    <div class="timeline-item">
                                        <div class="timeline-icon-wrap">
                                            <img :src="$asset('/hkcm/images/orchester/clock_icon2230.png', 'public')" style="width: 30px; height: 30px" alt="" />
                                        </div>
                                        <p class="timeline-time"><strong>ca. 22:30 Uhr</strong><br />Ausklang</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ⑧ CTA SECTION (blue) -->
        <section id="tickets" class="cta-section">
            <div class="cta-bg"></div>
            <img class="cta-bg1" :src="$asset('/hkcm/images/orchester/cta_bg1.png', 'public')" alt="" />
            <img class="cta-bg2" :src="$asset('/hkcm/images/orchester/cta_bg2.png', 'public')" alt="" />
            <div class="cta-content">
                <div class="cta-text-area">
                    <h2 class="cta-title">Möchten Sie <span style="color: #031837">Teil</span> dieses<br />Abends sein?</h2>
                    <p class="body-text-white" style="text-align: center">
                        Wenn Sie an diesem besonderen kulturellen Erlebnis teilnehmen möchten, buchen Sie hier direkt Ihr Ticket.
                    </p>
                </div>
                <div class="cta-action-area">
                    <a href="https://partnershop.easyticket.de/1eb7fd2b345e9e5b144581cb5cb5f927/event/105586/" class="cta-btn">
                        Jetzt Ticket buchen*
                        <img :src="$asset('/hkcm/images/orchester/arrow_right_icon.svg', 'public')" style="width: 24px; height: 24px" alt="" />
                    </a>
                    <p class="cta-smallprint">*Die Teilnahme ist kostenfrei. Anreise & Übernachtung erfolgen in Eigenregie. Jeder Kunde kann bis zu 4 Tickets reservieren.</p>
                </div>
                <div class="cta-award-badges">
                    <div class="award-badge-circle">
                        <img :src="$asset('/hkcm/images/orchester/badge_blackbull.jpg', 'public')" alt="Black Bull Award" />
                    </div>
                    <div class="award-badge-circle">
                        <img :src="$asset('/hkcm/images/orchester/badge_investment1.jpg', 'public')" alt="Investment Award" />
                    </div>
                    <div class="award-badge-circle">
                        <img :src="$asset('/hkcm/images/orchester/badge_investment2.png', 'public')" alt="Award" />
                    </div>
                </div>
            </div>
        </section>

        <!-- ⑨ TICKER BOTTOM -->
        <div class="ticker-bar">
            <p v-for="(item, index) in 25" :key="index" class="ticker-text">
                +++ Exklusives Event für ausgewählte Gäste +++ Ein Abend, der <span style="font-weight: 600">Musik und Märkte</span> neu verbindet +++ Dialog, Vielfalt und
                <span style="font-weight: 600">neue Denkansätze</span> +++
            </p>
        </div>

        <!-- ⑩ FINAL SECTION + FOOTER -->
        <section class="final-section">
            <div class="final-bg"></div>
            <div class="final-gradient"></div>
            <div class="final-content">
                <img :src="$asset('/hkcm/images/orchester/hkcm_logo_final.svg', 'public')" class="final-logo" alt="HKCM" />
                <div class="final-text-area">
                    <h2 class="final-title"><span style="color: #006cff">Kultur</span> verbindet.<br />Verantwortung verpflichtet.</h2>
                    <p class="body-text-white" style="text-align: center">
                        HKCM steht für analytische Klarheit und für einen respektvollen Umgang mit Vielfalt.<br />
                        Wir freuen uns auf einen Abend, der Perspektiven erweitert.
                    </p>
                </div>
            </div>
        </section>
    </div>
    <!-- Footer -->
    <LandingFooter
        background-color="#FFFFFF"
        logo="/hkcm/images/logo-on-light-background.svg"
        logo-link="/produkte"
        link-color="text-gray-600"
        cta-link="/produkte"
        button-gradient-from="#006CFF"
        button-gradient-to="#006CFF"
        link-classes="uppercase"
    />
</template>

<script setup>
// No external components – pixel-perfect inline build
import LandingFooter from '../components/landing/LandingFooter.vue';
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Sacramento&display=swap');
</style>

<style scoped>
/* ─── ROOT ─────────────────────────────────────────── */
.orchester-page {
    font-family: 'Montserrat', sans-serif;
    overflow-x: hidden;
    background: #ffffff;
}

/* ─── SHARED ─────────────────────────────────────────── */
.section-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #006cff;
    color: #ffffff;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 18.2px;
    padding: 5px 9px;
    border-radius: 8px;
    width: fit-content;
    text-transform: uppercase;
}

.body-text-dark {
    font-family:
        'SF Pro Text',
        'SF Pro Display',
        -apple-system,
        BlinkMacSystemFont,
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 23.4px;
    color: #031837;
    margin: 0;
}

.body-text-white {
    font-family:
        'SF Pro Text',
        'SF Pro Display',
        -apple-system,
        BlinkMacSystemFont,
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 23.4px;
    color: #ffffff;
    margin: 0;
}

.feature-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* ─── TICKER ─────────────────────────────────────────── */
.ticker-bar {
    background: #ffffff;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 15px 0;
    overflow: hidden;
}

.ticker-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 23.4px;
    color: #000000;
    margin: 0;
    white-space: nowrap;
    display: inline-block;
    animation: ticker-scroll 120s linear infinite;
}

/* ─── HERO ─────────────────────────────────────────── */
.hero-section {
    position: relative;
    height: 1038px; /* 1091 - 53px ticker which is outside */
    overflow: hidden;
    background: #031837;
}

.hero-bg {
    position: absolute;
    inset: 0;
    background-image: url('/hkcm/images/orchester/hero_bg.jpg');
    background-size: cover;
    background-position: center top;
    z-index: 0;
    filter: blur(2px);
}

.hero-concert-img {
    position: absolute;
    left: 27%; /* 389/1440 */
    top: 150px; /* 203px - 53px ticker offset */
    width: 73%; /* 1051/1440 */
    height: 670px;
    object-fit: cover;
    object-position: center top;
    z-index: 1;
}

.hero-gradient {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(3, 24, 55, 0) 0%, rgba(3, 24, 55, 1) 100%);
    z-index: 3;
}

.hero-gradient-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 420px;
    background: linear-gradient(to bottom, rgba(8, 21, 37, 0) 0%, rgba(8, 21, 37, 1) 100%);
    z-index: 2;
}

.hero-nav-wrap {
    position: absolute;
    top: 20px; /* 73px from hero - but ticker is outside, so 73-53=20 */
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    padding: 0 120px;
    z-index: 10;
}

.hero-nav {
    width: 100%;
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border-radius: 50px;
    padding: 16px 24px;
}

.hero-logo {
    height: 50px;
    width: auto;
}

.hero-nav-links {
    text-transform: uppercase;
    display: flex;
    align-items: center;
}

.hero-nav-link {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 17.1px;
    color: #ffffff;
    text-decoration: none;
    padding: 10px 20px;
}

.hero-nav-link:hover {
    opacity: 0.8;
}

.hero-nav-cta {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: #006cff;
    color: #ffffff;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.5px;
    text-decoration: none;
    padding: 10px 20px;
    border-radius: 50px;
}

.hero-content-wrap {
    position: absolute;
    top: 202px; /* 255px from hero - 53px ticker = 202px */
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    padding: 0 120px;
    z-index: 10;
}

.hero-content {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.hero-title-area {
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.hero-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 54px;
    font-weight: 600;
    line-height: 70.2px;
    color: #ffffff;
    margin: 0;
    text-align: left;
}

.hero-subtitle {
    font-family: 'Montserrat', sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    color: #ffffff;
    margin: 0;
    text-align: left;
}

.hero-cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: #006cff;
    color: #ffffff;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 19.5px;
    text-decoration: none;
    padding: 20px 20px;
    border-radius: 50px;
    width: fit-content;
}

.hero-badges-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
}

.hero-store-badges {
    display: flex;
    gap: 20px;
    align-items: center;
}

.hero-shadow {
    position: absolute;
    bottom: 30px;
    z-index: 1;
}

.store-badge-item {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.store-badge-img {
    height: 40px;
    width: 135px;
    object-fit: contain;
}

.store-rating {
    display: flex;
    align-items: center;
    gap: 5px;
}

.store-rating-num {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.8px;
    color: #ffffff;
}

.hero-award-badges {
    display: flex;
    gap: 12px;
    align-items: center;
}

.award-badge-circle {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    overflow: hidden;
    background: #ffffff;
    flex-shrink: 0;
}

.award-badge-circle img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* ─── VIDEO PLAYER SHARED ─────────────────────────────────────────── */
.video-play-btn {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.video-thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
    display: block;
}

/* ─── ÜBERZEUGUNG SECTION ─────────────────────────────────────────── */
.ueberzeugung-section {
    position: relative;
    margin-top: -230px; /* overlap with hero */
    z-index: 20;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 150px;
    padding-bottom: 150px;
}

.video-outer {
    width: 996px;
    height: 575px;
    background: rgba(0, 108, 255, 0.16);
    border-radius: 23px;
    padding: 15px;
    box-sizing: border-box;
    flex-shrink: 0;
    border: 2px solid #006cff;
}

.video-inner {
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba(217, 217, 217, 1);
    border-radius: 15px;
    overflow: hidden;
}

.synergie-video-outer {
    flex: 1;
    min-width: 0;
    width: auto;
    height: auto;
    flex-shrink: 1;
}

.synergie-video-inner {
    height: auto;
}

.ueberzeugung-content {
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.ueberzeugung-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 44px;
    font-weight: 600;
    line-height: 57.2px;
    color: #031837;
    margin: 10px 0 0 0;
    text-align: center;
}

.ueberzeugung-texts {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-top: 30px;
    max-width: 847px;
    text-align: center;
}

/* ─── VERBINDUNG SECTION ─────────────────────────────────────────── */
.verbindung-section {
    position: relative;
    overflow: hidden;
    padding: 150px 120px;
}

.verbindung-bg {
    position: absolute;
    inset: 0;
    background-image: url('/hkcm/images/orchester/section2_bg.jpg');
    background-size: cover;
    background-position: center;
    z-index: 0;
}

.verbindung-gradient {
    position: absolute;
    inset: 0;
    background: linear-gradient(to left, rgba(7, 36, 77, 1) 0%, rgb(7 36 77) 35%, rgb(7 36 77 / 0%) 100%);
    z-index: 1;
}

.verbindung-content-wrap {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 50px;
}

.verbindung-video-outer {
    width: 609px;
    min-width: 609px;
    height: 351px;
    background: rgba(0, 108, 255, 0.16);
    border-radius: 23px;
    padding: 15px;
    box-sizing: border-box;
    border: 2px solid #006cff;
}

.verbindung-video-inner {
    position: relative;
    width: 100%;
    height: 100%;
    background: rgba(217, 217, 217, 1);
    border-radius: 15px;
    overflow: hidden;
}

.verbindung-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.verbindung-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 44px;
    font-weight: 700;
    line-height: 57.2px;
    color: #ffffff;
    margin: 0;
    text-align: left;
}

.verbindung-features {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.verbindung-quote {
    font-family:
        SF Pro Text,
        'SF Pro Display',
        -apple-system,
        BlinkMacSystemFont,
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 23.4px;
    color: #ffffff;
    margin: 0;
    text-align: left;
}

/* ─── SYNERGIE SECTION ─────────────────────────────────────────── */
.synergie-section {
    background: #ffffff;
    padding: 150px 120px;
}

.synergie-content-wrap {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 50px;
}

.synergie-text {
    width: 539px;
    min-width: 539px;
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.synergie-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 44px;
    font-weight: 700;
    line-height: 57.2px;
    color: #031837;
    margin: 0;
    text-align: left;
}

.synergie-list-area {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.synergie-features {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 5px;
}

.synergie-image-outer {
    flex: 1;
    height: 482px;
    background: rgba(0, 108, 255, 0.16);
    border-radius: 24px;
    padding: 16px;
    box-sizing: border-box;
    border: 2px solid #006cff;
}

.synergie-image-inner {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
}

.synergie-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* ─── DIALOG SECTION ─────────────────────────────────────────── */
.dialog-section {
    position: relative;
    overflow: hidden;
    padding: 150px 120px;
    height: 63.5rem;
    display: flex;
    flex-direction: column-reverse;
}

.dialog-bg {
    position: absolute;
    inset: 0;
    background-image: url('/hkcm/images/orchester/dialog_bg.jpg');
    background-size: cover;
    background-position: center -110px;
    z-index: 0;
}

.dialog-gradient {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(7, 37, 81, 0.92) 20%, rgb(2 14 32 / 0%) 100%);
    z-index: 1;
}

.dialog-content-wrap {
    position: relative;
    z-index: 2;
    max-width: 967px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
}

.dialog-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.dialog-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 44px;
    font-weight: 700;
    line-height: 57.2px;
    color: #ffffff;
    margin: 0;
    text-align: center;
}

.dialog-cards {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: center;
    width: 100%;
}

.dialog-card {
    flex: 1;
    background: #031837;
    border-radius: 16px;
    padding: 13px 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    min-height: 107px;
    border: 1px solid white;
}

.dialog-card-icon {
    width: 80px;
    height: 80px;
    object-fit: contain;
    flex-shrink: 0;
}

.dialog-card-divider {
    width: 1px;
    height: 80px;
    background: rgba(255, 255, 255, 0.2);
    flex-shrink: 0;
}

.dialog-card-text {
    font-family:
        'SF Pro Text',
        'SF Pro Display',
        -apple-system,
        BlinkMacSystemFont,
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    color: #ffffff;
    margin: 0;
}

/* ─── EVENT SECTION ─────────────────────────────────────────── */
.event-section {
    background: #fffdf5;
    padding: 150px 120px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.event-box-wrap {
    position: relative;
    width: 994px;
    min-height: 570px;
}

.event-box {
    position: relative;
    width: 100%;
    padding: 50px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid rgba(233, 186, 103, 0.5);
    border-radius: 55px;
}

.corner {
    position: absolute;
    width: 95px;
    height: 95px;
}

.corner-tl {
    top: 0;
    left: 0;
}

.corner-tr {
    top: 0;
    right: 0;
}

.corner-bl {
    bottom: 0;
    left: 0;
}

.corner-br {
    bottom: 0;
    right: 0;
}

.event-inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
}

.event-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    width: 100%;
}

.event-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 44px;
    font-weight: 600;
    line-height: 57.2px;
    color: #031837;
    margin: 0;
    text-align: center;
}

.event-meta {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
}

.event-meta-row {
    display: flex;
    flex-direction: row;
    gap: 24px;
    align-items: center;
}

.event-meta-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 14px;
}

.event-meta-icon-wrap {
    width: 44px;
    height: 44px;
    background: rgba(243, 219, 173, 0.5);
    border-radius: 10.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.event-meta-text {
    font-family:
        'SF Pro Text',
        'SF Pro Display',
        -apple-system,
        BlinkMacSystemFont,
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20.8px;
    color: #031837;
    margin: 0;
}

.event-timeline-wrap {
    position: relative;
    width: 100%;
    max-width: 592px;
}

.event-timeline-bar {
    position: absolute;
    top: 20px;
    width: 578px;
    height: 8px;
    background: #e9ba67;
    border-radius: 16px;
    margin: 0 auto 20px;
}

.event-timeline {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: row;
    gap: 24px;
    justify-content: center;
}

.timeline-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    width: 130px;
}

.timeline-icon-wrap {
    width: 44px;
    height: 44px;
    background: rgba(248, 235, 208, 1);
    border-radius: 10.5px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.timeline-time {
    font-family:
        'SF Pro Text',
        'SF Pro Display',
        -apple-system,
        BlinkMacSystemFont,
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 18px;

    line-height: 23.4px;
    color: #031837;
    margin: 0;
    text-align: center;
}

.timeline-label {
    font-family:
        'SF Pro Text',
        'SF Pro Display',
        -apple-system,
        BlinkMacSystemFont,
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 23.4px;
    color: #031837;
    margin: 0;
    text-align: center;
}

/* ─── CTA SECTION ─────────────────────────────────────────── */
.cta-section {
    position: relative;
    overflow: hidden;
}

.cta-bg {
    position: absolute;
    inset: 0;
    background-image: url('/hkcm/images/orchester/cta_bg.jpg');
    background-size: cover;
    background-position: center;
    z-index: 0;
}

.cta-bg::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 108, 255, 0.9);
}

.cta-content {
    position: relative;
    z-index: 2;

    margin: 0 auto;
    padding: 50px 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
}

.cta-text-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
}

.cta-bg1 {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 1;
}
.cta-bg2 {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 300px;
    height: 300px;
    z-index: 1;
}

.cta-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 600;
    line-height: 41.6px;
    color: #ffffff;
    margin: 0;
    text-align: center;
}

.cta-action-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: #ffffff;
    color: #006cff;
    font-family: 'Montserrat', sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    text-decoration: none;
    padding: 16px 24px;
    border-radius: 50px;
    width: fit-content;
}

.cta-smallprint {
    font-family:
        'SF Pro Text',
        'SF Pro Display',
        -apple-system,
        BlinkMacSystemFont,
        'Helvetica Neue',
        Arial,
        sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 23.4px;
    color: #ffffff;
    margin: 0;
    text-align: center;
}

.cta-award-badges {
    backdrop-filter: blur(4px);
    display: flex;
    gap: 16px;
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 500px;
    padding: 16px;
}

/* ─── FINAL SECTION ─────────────────────────────────────────── */
.final-section {
    position: relative;
    overflow: hidden;
    padding-top: 250px;
    padding-bottom: 150px;
}

.final-bg {
    position: absolute;
    inset: 0;
    background-image: url('/hkcm/images/orchester/footer_bg.png');
    background-size: cover;
    background-position: center;
    z-index: 0;
}

.final-gradient {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, #07244d24 0%, #020f22 78%, #020f22 100%);
    z-index: 1;
}

.final-content {
    position: relative;
    z-index: 2;
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
}

.final-logo {
    width: 204px;
    height: auto;
}

.final-text-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
}

.final-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 44px;
    font-weight: 700;
    line-height: 57.2px;
    color: #ffffff;
    margin: 0;
    text-align: center;
}

.final-footer {
    position: relative;
    z-index: 2;
}

.final-footer-line {
    height: 1px;
    background: rgba(255, 255, 255, 0.15);
    margin: 0;
}

.final-footer-inner {
    background: #ffffff;
    padding: 15px 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 100%;
}

.footer-logo {
    height: 50px;
    width: 169px;
    object-fit: contain;
}

.footer-nav {
    display: flex;
    align-items: center;
}

.footer-nav-link {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: #031837;
    text-decoration: none;
    padding: 10px 20px;
}

.footer-nav-link:hover {
    opacity: 0.7;
}

.footer-cta-btn {
    display: inline-flex;
    align-items: center;
    background: #006cff;
    color: #ffffff;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.5px;
    text-decoration: none;
    padding: 10px 20px;
    border-radius: 50px;
}

/* ─── MOBILE ──────────────────────────────────────────────────── */
@keyframes ticker-scroll {
    from {
        transform: translateX(25vw);
    }
    to {
        transform: translateX(-1000%);
    }
}

@media (max-width: 1250px) {
    /* ─── TICKER ─── */
    .ticker-text {
        font-size: 16px;
    }

    /* ─── HERO ─── */
    .hero-section {
        height: 830px;
    }

    .hero-concert-img {
        left: 0;
        top: 320px;
        width: 100%;
        height: 421px;
        object-fit: cover;
        object-position: center top;
    }

    .hero-bg {
        background-size: cover;
        background-position: -795px -70px;
        z-index: 0;
        filter: brightness(0.5);
    }

    .hero-gradient {
        background: none;
    }

    .hero-gradient-overlay {
        top: 430px;
        height: 503px;
    }

    .hero-nav-wrap {
        top: 16px;
        padding: 0 20px;
    }

    .hero-nav {
        padding: 10px 14px;
    }

    .hero-nav-links {
        display: none;
    }

    .hero-logo {
        height: 36px;
    }

    .hero-nav-cta {
        font-size: 14px;
        padding: 8px 14px;
    }

    .hero-content-wrap {
        top: 122px;
        padding: 0 20px;
    }

    .hero-content {
        gap: 50px;
    }

    .hero-title-area {
        gap: 16px;
    }

    .hero-title {
        text-align: center;
        font-size: 32px;
        line-height: 41.6px;
    }

    .hero-subtitle {
        text-align: center;
        font-size: 20px;
        line-height: 26px;
    }

    .hero-cta-btn {
        width: 100%;
        box-sizing: border-box;
        justify-content: center;
        padding: 20px;
    }

    .hero-badges-row {
        flex-direction: column;
        gap: 30px;
        align-items: center;
    }

    .hero-store-badges {
        display: none;
        gap: 12px;
    }

    .store-badge-img {
        width: 120px;
        height: 36px;
    }

    .hero-award-badges {
        gap: 10px;
    }

    /* ─── ÜBERZEUGUNG ─── */
    .ueberzeugung-section {
        margin-top: -99px;
        gap: 80px;
        padding: 0 20px 80px;
        align-items: flex-start;
    }

    .video-outer {
        width: 100%;
        height: auto;
        padding: 8px;
        border-radius: 16px;
        box-sizing: border-box;
        align-self: stretch;
    }

    .ueberzeugung-content {
        max-width: 100%;
        align-items: flex-start;
        gap: 10px;
    }

    .ueberzeugung-title {
        font-size: 26px;
        line-height: 33.8px;
        text-align: left;
    }

    .ueberzeugung-texts {
        text-align: left;
        max-width: 100%;
        margin-top: 20px;
        align-items: unset;
    }

    /* ─── VERBINDUNG ─── */
    .verbindung-section {
        padding: 80px 20px;
    }

    .verbindung-bg {
        position: absolute;
        inset: 0;
        background-position: -32px -100px;
        z-index: 0;
        background-repeat: no-repeat;
        background-size: 130%;
    }

    .verbindung-content-wrap {
        flex-direction: column;
        gap: 80px;
    }

    .verbindung-video-outer {
        width: 100%;
        height: auto;
        min-width: 0;
        padding: 8px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .verbindung-title {
        font-size: 26px;
        line-height: 33.8px;
    }

    .verbindung-quote {
        font-size: 18px;
        line-height: 26px;
    }

    .verbindung-gradient {
        position: absolute;
        inset: 0;
        background: linear-gradient(to top, rgba(7, 36, 77, 1) 50%, rgb(7 36 77 / 0%) 100%);
        z-index: 1;
    }

    .verbindung-media {
        width: 100%;
    }

    /* ─── SYNERGIE ─── */
    .synergie-section {
        padding: 80px 20px;
    }

    .synergie-content-wrap {
        flex-direction: column-reverse; /* Bild oben (letztes DOM-Kind), Text darunter */
        gap: 40px;
    }

    .synergie-text {
        gap: 30px;
        width: 100%;
        min-width: 0;
    }

    .synergie-title {
        font-size: 26px;
        line-height: 33.8px;
    }

    .synergie-image-inner {
        height: 267px;
    }

    .synergie-image-outer {
        width: 100%;
        height: 283px;
        border-radius: 16px;
        padding: 5px;
    }

    .synergie-img {
        transform: scale(1.2);
    }

    /* ─── DIALOG / BEGEGNUNG ─── */
    .dialog-section {
        height: 1116px;
        padding: 80px 20px;
    }

    .dialog-bg {
        position: absolute;
        inset: 0;
        background-position: top;
        z-index: 0;
        background-repeat: no-repeat;
        background-size: 100%;
        background-image: url('/hkcm/images/orchester/dialog_bg_mobile.png');
    }

    .dialog-gradient {
        background: linear-gradient(to top, rgba(7, 36, 77, 1) 0%, rgb(7 36 77) 65%, rgb(7 36 77 / 0%) 80%, rgb(7 36 77 / 0%) 100%);
    }

    .dialog-content-wrap {
        max-width: 100%;
        gap: 30px;
    }

    .dialog-title {
        font-size: 26px;
        line-height: 33.8px;
    }

    .dialog-cards {
        flex-direction: column;
        align-items: center;
        gap: 24px;
    }

    .dialog-card {
        max-width: 300px;
        width: 100%;
    }

    /* ─── EVENT DETAILS ─── */
    .event-section {
        padding: 80px 20px;
    }

    .event-box-wrap {
        width: 100%;
        min-height: auto;
    }

    .event-box {
        padding: 30px 20px;
    }

    .event-title {
        font-size: 26px;
        line-height: 33.8px;
    }

    .event-meta-row {
        width: 100%;
        max-width: 592px;
        flex-direction: column;
        gap: 20px;
        align-items: flex-start;
    }

    .event-timeline-bar {
        display: none;
    }

    .event-timeline {
        flex-direction: column;
        gap: 20px;
        justify-content: flex-start;
    }

    .timeline-item {
        flex-direction: row;
        width: 100%;
        align-items: center;
        gap: 14px;
        justify-content: flex-start;
    }

    .timeline-time {
        text-align: left;
        min-width: 110px;
    }

    .timeline-label {
        text-align: left;
    }

    /* ─── CTA SECTION ─── */
    .cta-content {
        padding: 80px 20px;
    }

    .cta-text-area {
        gap: 30px;
    }

    .cta-title {
        font-size: 26px;
        line-height: 33.8px;
    }

    .cta-action-area {
        width: 100%;
    }

    .cta-btn {
        width: 100%;
        justify-content: center;
        box-sizing: border-box;
    }

    .cta-bg1 {
        display: none;
    }

    .cta-award-badges {
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
    }

    /* ─── FINAL SECTION ─── */
    .final-content {
        padding: 0;
        max-width: 100%;
    }

    .final-section {
        padding-top: 80px;
        padding-bottom: 80px;
        padding-left: 20px;
        padding-right: 20px;
    }

    .final-title {
        font-size: 26px;
        line-height: 33.8px;
    }

    .final-text-area {
        gap: 30px;
    }

    .final-gradient {
        position: absolute;
        inset: 0;
        background: linear-gradient(to top, rgba(2, 15, 34, 1) 40%, rgb(2 15 34 / 0%) 100%);
        z-index: 1;
    }

    .final-bg {
        position: absolute;
        inset: 0;
        background-image: url(/hkcm/images/orchester/footer_bg.png);
        background-size: 140%;
        background-position: top;
        z-index: 0;
        background-repeat: no-repeat;
    }

    /* ─── FOOTER ─── */
    .final-footer-inner {
        flex-direction: column;
        align-items: center;
        gap: 20px;
        padding: 15px 16px;
    }

    .footer-nav {
        flex-wrap: wrap;
        justify-content: center;
    }

    .footer-cta-btn {
        width: 100%;
        justify-content: center;
        text-align: center;
        box-sizing: border-box;
    }
}

@media (max-width: 600px) {
    .video-outer {
        //height: 201px;
    }
}
</style>
